import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';

export const NotFoundPage: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center pt-16 px-4">
    <div className="glass-card p-10 rounded-2xl text-center max-w-md">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-amber-500/10 border border-amber-500/20 mb-6">
        <FaExclamationTriangle className="text-4xl text-amber-400" />
      </div>
      <h1 className="text-5xl font-extrabold text-white mb-3">404</h1>
      <h2 className="text-xl font-semibold text-gray-300 mb-4">
        Pagina non trovata
      </h2>
      <p className="text-gray-400 mb-8 text-sm">
        La pagina che stai cercando non esiste o è stata spostata.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-medium hover:from-indigo-500 hover:to-purple-500 transition-all shadow-lg shadow-indigo-600/20"
      >
        <FaHome />
        Torna alla Home
      </Link>
    </div>
  </div>
);
